<template>
<page-wrapper>
  <v-data-table v-if="!ordering" :headers="headers" :items="websiteProjects"
                :items-per-page="50" :footer-props="{ itemsPerPageOptions: [25, 50, 100, -1] }"
                :loading="loading">
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title class="title">Website Projects</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text small @click="startOrdering">Change order</v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.job_number="{ item }">
      <span v-if="item.job_number">{{ item.job_number }}</span>
    </template>
    <template v-slot:item.sync="{ item }">
      <v-icon small :color="item.sync ? 'green' : 'grey lighten-2'">
        {{ item.sync ? 'mdi-check-circle' : 'mdi-circle-outline' }}
      </v-icon>
    </template>
    <template v-slot:item.featured="{ item }">
      <v-icon v-if="item.featured" small color="indigo darken-1">mdi-star</v-icon>
    </template>
    <template v-slot:item.edit="{ item }">
      <v-icon small @click="editItem(item)">mdi-pencil</v-icon>
    </template>
  </v-data-table>

  <div v-else>
    <v-toolbar flat>
      <v-toolbar-title class="title">Website Projects — reordering</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn text small @click="ordering = false">Cancel</v-btn>
      <v-btn text small color="primary" @click="saveOrder">Save order</v-btn>
    </v-toolbar>

    <table class="order-table">
      <thead>
        <tr>
          <th></th>
          <th>ID</th>
          <th>Title</th>
          <th>Client</th>
          <th>Year</th>
          <th></th>
        </tr>
      </thead>
      <draggable v-model="orderedProjects" tag="tbody" handle=".drag-handle">
        <tr v-for="item in orderedProjects" :key="item.id">
          <td><v-icon class="drag-handle" small>mdi-drag</v-icon></td>
          <td class="grey--text">{{ item.id }}</td>
          <td>{{ item.title }}</td>
          <td class="grey--text">{{ item.client }}</td>
          <td class="grey--text">{{ item.year }}</td>
          <td><v-icon small @click="sendToTop(item)">mdi-arrow-up</v-icon></td>
        </tr>
      </draggable>
    </table>
  </div>

  <v-dialog v-model="editing" max-width="800px">
    <edit-website-project ref="editor" @close="onClose"></edit-website-project>
  </v-dialog>
</page-wrapper>
</template>

<script>
import { mapState } from 'vuex'
import draggable from 'vuedraggable'
import * as api from '../api'
import PageWrapper from '../components/ui/PageWrapper'
import EditWebsiteProject from '../components/website/EditWebsiteProject'

export default {
  name: 'WebsiteProjects',
  components: { PageWrapper, EditWebsiteProject, draggable },
  props: {
    editId: { type: Number, default: null }
  },
  data() {
    return {
      loading: true,
      editing: false,
      ordering: false,
      orderedProjects: [],
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Job', value: 'job_number' },
        { text: 'Title', value: 'title' },
        { text: 'Client', value: 'client' },
        { text: 'Year', value: 'year' },
        { text: '', value: 'sync' },
        { text: '', value: 'featured' },
        { text: '', value: 'edit', sortable: false }
      ]
    }
  },
  computed: {
    ...mapState(['websiteProjects'])
  },
  methods: {
    editItem(item) {
      this.$router.replace({ name: 'website-projects', params: { id: item.id } }).catch(() => {})
      this.editing = true
      this.$nextTick(() => { this.$refs.editor.setProject(item) })
    },
    onClose() {
      this.editing = false
      this.$router.replace({ name: 'website-projects' }).catch(() => {})
    },
    startOrdering() {
      this.orderedProjects = this.websiteProjects.sort((a, b) => a.order - b.order)
      this.ordering = true
    },
    sendToTop(item) {
      this.orderedProjects = [item, ...this.orderedProjects.filter(p => p.id !== item.id)]
    },
    async saveOrder() {
      await api.putJson('/website/projects/order', this.orderedProjects.map(p => p.id))
      await this.$store.dispatch('getWebsiteProjects', true)
      this.ordering = false
    }
  },
  async mounted() {
    await this.$store.dispatch('getWebsiteProjects')
    this.loading = false
    if (this.editId) {
      const project = this.websiteProjects.find(p => p.id === this.editId)
      if (project) this.editItem(project)
    }
  }
}
</script>

<style scoped lang="scss">
.order-table {
  width: 100%;
  border-collapse: collapse;

  th {
    text-align: left;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    color: #888;
    padding: 6px 12px;
    border-bottom: 1px solid #e0e0e0;
  }

  td {
    padding: 8px 12px;
    border-bottom: 1px solid #f0f0f0;
    font-size: 0.875rem;
  }

  .drag-handle {
    cursor: grab;
    &:active { cursor: grabbing; }
  }
}
</style>
